import { request } from 'redukers'

export const getContractStatus = (state) => state.contractStatus.contractStatus
export const getIsContractStatusFetching = (state) => request.getIsRequesting(state.contractStatus.loadContractStatusRequest)
export const getIsContractStatusError = (state) => request.getIsError(state.contractStatus.loadContractStatusRequest)
